export default class DMAStorageService {
    constructor() {
        this.localStorageName = 'dmaInfo';
        this.localStorageLocation = 'storageLocation';
        this.temporalCookieName = 'localTvSlug';
    }

    getStorageDMA() {
        let dmaInfo;
        try {
            dmaInfo = JSON.parse(localStorage.getItem(this.localStorageName));
            return dmaInfo;
        } catch (error) {
            return dmaInfo = null;
        }
    }

    getDMAUrlDataAdapterSchedule(){
        
        try {
            let dmaUrlData = '';
            let storageDMA = this.getStorageDMA();
            if(storageDMA) {
                storageDMA.forEach((dmaInfo) => {
                    if (dmaInfo.dma && dmaInfo.stationId) {
                        dmaUrlData +=
                            dmaUrlData != '' ? ',' : '';
                        dmaUrlData +=
                            dmaInfo.dma +
                            '|' +
                            dmaInfo.stationId +
                            '|' +
                            dmaInfo.stationSlug;
                    }
                });
                return dmaUrlData;
            }
        } catch (error) { 
            this.removeStorageDMA();
        }
        return '';
    }

    getDMAStationIdStringOnNow() {
        try {
            let dma = '';
            let stationId = '';
            let storageDMA = this.getStorageDMA();
            if(storageDMA) {
                storageDMA.forEach((dmaInfo) => {
                    if (dmaInfo.dma && dmaInfo.stationId) {
                        dma += dma != '' ? ',' : '';
                        dma += dmaInfo.dma;
                        stationId += stationId != '' ? ',' : '';
                        stationId += dmaInfo.stationId;
                    }
                });
                return [dma,stationId];
            }
        } catch (error) { }
        return [null, null];
    }

    getCurrentLocation() {
        return JSON.parse(localStorage.getItem(this.localStorageLocation));
    }

    setCurrentLocation(location) {
        localStorage.setItem(this.localStorageLocation, JSON.stringify(location));
    }

    setStorageDMA(dmaInfo) {
        localStorage.setItem(this.localStorageName, JSON.stringify(dmaInfo));
    }

    removeStorageDMA() {
        localStorage.removeItem(this.localStorageName);
    }
}
